// Module
var code = "<div id=\"VAIMISUtility_QueryEditorOpener\" class=\"query-editor-opener\"> <div class=\"query-editor-opener-header\"> <a href=\"javascript: void(0);\">&#x2716;</a> </div> <input type=\"text\" placeholder=\"Enter Query Path\"/> <p>Hint: hit the escape key to close this window</p> <div class=\"query-editor-error-container\"></div> </div>";
// Exports
export default code;